import React, { useEffect, useState } from 'react';
import axios from 'axios';
import DOMPurify from 'dompurify';
import { BookOpenCheck, ChevronRight, Target } from 'lucide-react';
import InfoPanel from './InfoPanel';
import { API_BASE } from '../../config/api';

const API = `${API_BASE}/api`;

const ModuleRow = ({ mod, index }) => {
  const [open, setOpen] = useState(index === 0);
  return (
    <div className="border-t border-zinc-800 first:border-t-0" data-testid={`learner-outline-module-${index}`}>
      <button type="button" onClick={() => setOpen(!open)} className="w-full flex items-start gap-2 py-3 text-left" data-testid={`learner-outline-module-toggle-${index}`}>
        <ChevronRight className={`h-4 w-4 mt-0.5 text-teal-400 transition-transform ${open ? 'rotate-90' : ''}`} />
        <span className="flex-1">
          <span className="block text-white font-medium">{mod.title}</span>
          <span className="block text-sm text-zinc-400">{mod.summary}</span>
        </span>
      </button>
      {open && (
        <ul className="pl-6 pb-3 space-y-2">
          {mod.weeks.map((w, i) => (
            <li key={i} className="text-sm border-l-2 border-teal-500/40 pl-3">
              <span className="text-zinc-200">{w.title}</span>
              <span className="block text-zinc-500">{w.summary}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default function ProgrammeOutlineCard({ programmeId, token, open, onToggle }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API}/programmes/${programmeId}/my-outline`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setData(r.data))
      .catch(() => setData(null));
  }, [programmeId, token]);

  if (!data?.approved) return null;
  return (
    <InfoPanel testId="learner-course-outline" title="Course Outline" icon={BookOpenCheck} open={open} onToggle={onToggle}>
      <div className="space-y-5 pt-3">
        <div className="rich-content text-zinc-300" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data.overview_html || '') }} />
        {data.learning_outcomes?.length > 0 && (
          <div>
            <p className="text-sm font-medium text-zinc-200 mb-2 flex items-center gap-2"><Target className="h-4 w-4 text-teal-400" /> What you will be able to do</p>
            <ul className="grid sm:grid-cols-2 gap-x-6 gap-y-1.5 text-sm text-zinc-400 list-disc pl-5" data-testid="learner-outline-outcomes">
              {data.learning_outcomes.map((o, i) => <li key={i}>{o}</li>)}
            </ul>
          </div>
        )}
        <div>{(data.modules || []).map((m, i) => <ModuleRow key={i} mod={m} index={i} />)}</div>
      </div>
    </InfoPanel>
  );
}
